<template>
  <div id="app">
    <pulse-loader class="w-100 h-100 text-center"  style="top:50%" :loading="isLoading"></pulse-loader>
    <router-view v-if="!isLoading" />
    <Dialog/>
  </div>
</template>

<script>
  import PulseLoader from '@/app/components/PulseLoader.vue'
  import Dialog from '@/app/components/Dialog.vue'
  export default {
    name: 'App',
    components: {
      PulseLoader,
      Dialog
    },
    computed: {
      isLoading: function () {
        return this.$store.getters['spinner/show']
      },
    },
    created () {
      window.onpopstate = () => {
        let brandPath = null

        // URLから取得
        if ('brandPath' in this.$route.params) {
          brandPath = this.$route.params.brandPath
        } else {
          // SEM
          if (this.$store.getters['manager/exists'] && this.$store.getters['manager/authorityKbnName'] === 'system') {
            brandPath = process.env.VUE_APP_ADMIN_BRAND_PATH
          } else {
            // storeにあるbrand情報
            brandPath = this.$store.getters['brand/path']
          }
        }

        const error = {
          id: '800',
          code: '001',
          button: {
            path: { name: 'top', params: { brandPath: brandPath }},
          },
          canBack: brandPath !== '',
          message: 'ブラウザの戻るボタン、進むボタンは使用しないでください。',
        }

        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'historyError'}, () => {
          // Navigation Duplicate Error対策
          this.$router.push({name: 'error'})
        }))
      }
    }
  }
</script>
